module.exports = __webpack_public_path__ + "static/media/heroAbout.f9676f85.svg";